<template>
    <b-modal :id="id" dialog-class="modal-lg" @shown="shown" @ok="save" no-close-on-backdrop>
        <template slot="modal-header">
            <span>新生健康檢查報告資料</span>
            <b-button class="close" @click="cancel">
                <b-icon-x></b-icon-x>
            </b-button>
        </template>
        <div class="row">
            <div class="col-md-3 col-sm-12">
                <form-input v-model="vm.SYear" id="SYear" label="學年度" disabled></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
                <form-select v-model="vm.Semester" id="Semester" label="學期" required>
                    <div is="option" value="u">上</div>
                    <div is="option" value="d">下</div>
                </form-select>
            </div>
            <div class="col-md-3 col-sm-12">
                <form-input v-model="vm.StudentNo" id="StudentNo" label="學號" disabled></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
                <form-date-input v-model="vm.Date" id="Date" label="檢查日期" disabled></form-date-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.J" id="J" label="檢查者行動電話" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.K" id="K" label="年齡" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.L" id="L" label="身高" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.M" id="M" label="體重" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.N" id="N" label="腰圍" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.O" id="O" label="收縮壓SBP" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.P" id="P" label="舒張壓DBP" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.Q" id="Q" label="脈搏" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.R" id="R" label="身體質量指數BMI" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.S" id="S" label="視力(裸視)右眼" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.T" id="T" label="視力(裸視)左眼" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.U" id="U" label="視力(矯正)右眼" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.V" id="V" label="視力(矯正)左眼" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.W" id="W" label="辨色力" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.X" id="X" label="聽力(右耳)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.Y" id="Y" label="聽力(左耳)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.Z" id="Z" label="胸部正面X光" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AA" id="AA" label="頭頸部(淋巴腺 甲狀腺 結膜)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AB" id="AB" label="皮膚系統" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AC" id="AC" label="腹部" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AD" id="AD" label="耳鼻喉(耳部斜頸異常腫塊)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AE" id="AE" label="眼睛" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AF" id="AF" label="胸部(心肺疾病 胸廓異常)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AG" id="AG" label="脊柱四肢" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AH" id="AH" label="其他" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AI" id="AI" label="尿糖_Glucose" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AJ" id="AJ" label="尿蛋白_Protein" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AK" id="AK" label="尿酸鹼值_PH(u)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AL" id="AL" label="尿潛血_OB(u)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AM" id="AM" label="B型肝炎表面抗原_Hbs Ag" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AN" id="AN" label="B型肝炎表面抗體_Hbs Ab" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AO" id="AO" label="白血球_WBC" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AP" id="AP" label="紅血球_RBC" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AQ" id="AQ" label="血色素_Hgb" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AR" id="AR" label="血球容積比_Hct" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AS" id="AS" label="平均紅血球血紅素量_MCH" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AT" id="AT" label="平均紅血球容積_MCV" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AU" id="AU" label="平均紅血球血紅素濃度_MCHC" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AV" id="AV" label="血小板數目_Platelet" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AW" id="AW" label="總膽固醇_TC" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AX" id="AX" label="BUN" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AY" id="AY" label="肌酸酐_Crea" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.AZ" id="AZ" label="尿酸_UA" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BA" id="BA" label="轉氨酵素sGOT(AST)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BB" id="BB" label="轉氨酵素sGPT(ALT)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BC" id="BC" label="齲齒" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BD" id="BD" label="阻生牙" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BE" id="BE" label="缺牙" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BF" id="BF" label="已矯治" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BG" id="BG" label="贅生牙" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BH" id="BH" label="口腔衛生" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BI" id="BI" label="個人疾病史(無)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BJ" id="BJ" label="個人疾病史(肺結核)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BK" id="BK" label="個人疾病史(心臟病)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BL" id="BL" label="個人疾病史(肝炎)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BM" id="BM" label="個人疾病史(氣喘)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BN" id="BN" label="個人疾病史(腎臟病)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BO" id="BO" label="個人疾病史(癲癇)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BP" id="BP" label="個人疾病史(紅斑性狼瘡)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BQ" id="BQ" label="個人疾病史(血友病)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BR" id="BR" label="個人疾病史(蠶豆症)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BS" id="BS" label="個人疾病史(關節炎)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BT" id="BT" label="個人疾病史(糖尿病)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BU" id="BU" label="個人疾病史(癌症)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BV" id="BV" label="個人疾病史(海洋性貧血)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BW" id="BW" label="個人疾病史(心理或精神疾病)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BX" id="BX" label="個人疾病史(重大手術名稱)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BY" id="BY" label="個人疾病史(過敏物質名稱)" disabled></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.BZ" id="BZ" label="個人疾病史(其他)" disabled></form-input>
            </div>
        </div>
        <template slot="modal-footer">
            <b-button variant="info" @click="addtrack">列入個管追蹤名單</b-button>
            <b-button variant="secondary" @click="cancel"><b-icon-x></b-icon-x>關閉</b-button>
        </template>
    </b-modal>
</template>

<script>
    import { detail } from '@/views';
    export default detail({
        name: 'healthexaminationDetail',
        api: '/api/healthexamination/',
        methods: {
            addtrack: function () {
                return this.$http({ method: 'post', url: 'api/healthexamination/AddTrack', data: this.vm })
                    .then(() => {
                        this.$bvToast.toast('列入個管追蹤名單成功', { title: '', variant: 'success', solid: true });
                        this.$emit('reload');
                    })
            }
        },
    });
</script>

<style>
</style>